import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import Utils from 'app/Utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard   {
  constructor(private router: Router) { }
  public permissionList = new Array<string>()
  public includePermission : boolean;
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.permissionList=this.getCurrentUserPermissions();
      let roles = next.data.roles as Array<string>;

      roles.forEach(element => {
        if(this.permissionList.includes(element)){
          this.includePermission=true;
        }
      });

      if(this.includePermission) {
        this.includePermission=false;
        return true;
      }else{
        this.router.navigate(['']);
        return false;
      }
  }

  getCurrentUserPermissions(): Array<string> {
    return Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
  }
  
}
